import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from 'vue';

type BadgeType = 'disabled' | 'danger' | 'warning' | 'info' | 'link' | 'primary' | 'success';
type BadgeSize = 'small' | 'medium' | 'large';


export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
  type: {
    type: String as PropType<BadgeType>,
  },
  size: {
    type: String as PropType<BadgeSize>,
    default: 'small',
  },
},
  setup(__props) {

const props = __props;

const badgeClass = computed(() => `${badgeTypeClass.value} ${badgeSizeClass.value}`);
const badgeTypeClass = computed(() => 'is-' + (props.type ? props.type : 'disabled'));
const badgeSizeClass = computed(() => {
  if (props.size === 'large') {
    return 'large-tag';
  } else if (props.size === 'medium') {
    return 'medium-tag';
  } else {
    return 'small-tag';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["tag", badgeClass.value])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})